import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import Layout, { DocuLayout } from '../components/Layout';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DocuLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1>{`Orchestrator configuration`}</h1>
    <h2>{`Environmental variables at Docker`}</h2>
    <h3>{`Application configuration`}</h3>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}>{`ENV Variable`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Default value`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Note/Example`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`PAGE_URL`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td">{`required`}</strong></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`string`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Deployment url without training slash`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`https://foo.bar.com`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`APP_SECRET`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td">{`required`}</strong></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`string`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Random string used as a JWT secret`}</td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`COOKIE_DOMAIN`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td">{`required`}</strong></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`string`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Domain to set cookies`}</td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`MONGODB_CONNECTION_STRING`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td">{`required`}</strong>{` when using MongoDB`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`string`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`DB connection string`}</td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`MONGODB_DB`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><em parentName="td">{`extracted from connection string`}</em></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Override MongoDB database name`}</td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`COSMOSDB_CONNECTION_STRING`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td">{`required`}</strong>{` when using CosmosDB`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`string`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`DB connection string`}</td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`COSMOSDB_DB`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td">{`required`}</strong>{` when using CosmosDB`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`string`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`DB database name`}</td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`HSTS_MAX_AGE`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`2592000`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`number`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Max age header for HSTS`}</td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`X_FRAME_OPTIONS`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`DENY`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`string`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Allow using chat from an iframe`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`SAMEORIGIN`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`SENTRY_BACKEND_DSN`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`string`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Sentry DSN to report exceptions on backend`}</td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`SENTRY_FRONTEND_DSN`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`string`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Sentry DSN to report exceptions on frontend`}</td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`APPINSIGHTS_INSTRUMENTATIONKEY`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`string`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Enables Azure Application Insights error reporting`}</td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`VERBOSE_REQUEST_LOG`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`false`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`boolean`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Enables logging of request contents and responses`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><em parentName="td">{`has performance impacts`}</em></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`HIDE_VERBOSE_ERRORS`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`true`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`string`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Replaces user friendly error responses with generic "API Error" message`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><em parentName="td">{`stack traces are always hidden`}</em></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`JSON_CONFIGURATION`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`{}`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`string`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Static orchestrator configuration JSON`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><em parentName="td">{`described below`}</em></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`ALLOW_CORS_ORIGINS`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`*`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`string[]`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`List of allowed CORS origins`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><em parentName="td">{`use , as separator`}</em></td>
        </tr>
      </tbody>
    </table>
    <h3>{`Default orchestrator configuration`}</h3>
    <p>{`Following configuration is used, when no/empty `}<inlineCode parentName="p">{`JSON_CONFIGURATION`}</inlineCode>{` is provided.`}</p>
    <deckgo-highlight-code {...{
      "json": "",
      "line-numbers": "true",
      "highlight-lines": ""
    }}>{`
          `}<code parentName="deckgo-highlight-code" {...{
        "slot": "code"
      }}>{`{
    "pages": [
        { "id": "web", "primaryAppId": "bot" }
    ],
    "apps": [
        { "id": "bot" }
    ],
    "appToPage": [
        { "appId": "bot", "pageId": "web" }
    ]
}`}</code>{`
        `}</deckgo-highlight-code>
    <h3>{`Page Configuration`}</h3>
    <blockquote>
      <p parentName="blockquote">{`names of pages are transformed according to following example: `}<inlineCode parentName="p">{`fooBar--name0`}</inlineCode>{` to `}<inlineCode parentName="p">{`FOO_BAR_NAME0`}</inlineCode>{` (camel case to snake case except numbers, all foreign characters to single underscores)`}</p>
    </blockquote>
    <p><strong parentName="p">{`Common options`}</strong></p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}>{`ENV Variable`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Default value`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Configuration property`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Note/Example`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`PAGE_{page.id}_PRIMARY_APP_ID`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`string`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Default application to dispatch a thread`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`primaryAppId`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`PAGE_{page.id}_CHANNEL_NAME`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`wbaichat`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`string`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Channel type`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`channelName`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`wbaichat`}</inlineCode>{`, `}<inlineCode parentName="td">{`botservice`}</inlineCode>{`, `}<inlineCode parentName="td">{`facebook`}</inlineCode>{`, `}<inlineCode parentName="td">{`api`}</inlineCode>{`, `}<inlineCode parentName="td">{`vocalls`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`PAGE_{page.id}_CLIENT_ID`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`string`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Client identification, when the channel is connected behind messaging service`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`clientId`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`PAGE_{page.id}_CLIENT_SECRET`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`string`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Client secret, when the channel is connected behind messaging service`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`clientSecret`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`PAGE_{page.id}_START_ACTION_PAYLOAD`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`string`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Postback payload`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`startActionPayload`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><em parentName="td">{`supported by botservice, and vocalls (inbound call)`}</em></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`PAGE_{page.id}_LOAD_USER_TO_CONTEXT_PROP`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`string`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`If chanel provides user data, it's loaded into this prop`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`loadUserToContextProp`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><em parentName="td">{`supported by botservice, and vocalls`}</em></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`PAGE_{page.id}_API_URL`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`string`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`API url for services like vocalls, facebook etc.`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`apiUrl`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`https://vocalls.cz/calls`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`PAGE_{page.id}_TOKEN`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`string`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Token for API`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`token`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`PAGE_{page.id}_DEFAULT_VOICE_CONTROL_LANGUAGE`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`cs-CZ`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`string`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Voice language`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`defaultVoiceControl.language`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`PAGE_{page.id}_DEFAULT_VOICE_CONTROL_VOICE`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`string`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Voice type`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`defaultVoiceControl.voice`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`cs-CZ-AntoninNeural`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`PAGE_{page.id}_DEFAULT_VOICE_CONTROL_SPEED`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`1`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`number`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Voice speed`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`defaultVoiceControl.speed`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`0-2`}</inlineCode>{` ! Google TTS doesn't support values lower than 0.5`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`PAGE_{page.id}_DEFAULT_VOICE_CONTROL_PITCH`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`1`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`number`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Voice pitch`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`defaultVoiceControl.pitch`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`0-2`}</inlineCode>{` ! Google TTS doesn't support values lower than 0.5`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`PAGE_{page.id}_DEFAULT_VOICE_CONTROL_VOLUME`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`1`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`number`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Voice volume`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`defaultVoiceControl.volume`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`0-2`}</inlineCode>{` ! Google TTS doesn't support values lower than 0.5`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`PAGE_{page.id}_CALL_ACTION_PAYLOADS_OUTBOUND`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`string`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Outbound call payload`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`callActionPayloads.outbound`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Bot is calling to someone`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`PAGE_{page.id}_CALL_ACTION_PAYLOADS_DECLINED`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`string`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Declined call payload`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`callActionPayloads.declined`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`User didn't accept the call`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`PAGE_{page.id}_CALL_ACTION_PAYLOADS_HUNGUP`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`string`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Call hungup payload`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`callActionPayloads.hungup`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`User hung up the call`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`PAGE_{page.id}_CALL_ACTION_PAYLOADS_DIAL`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`string`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Dial payload `}<strong parentName="td">{`action`}</strong></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`callActionPayloads.dial`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`dial`}</inlineCode>{` needs payload data `}<inlineCode parentName="td">{`data.to = PHONE_NUMBER`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`PAGE_{page.id}_CALL_ACTION_PAYLOADS_HANGUP`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`string`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Hangup payload`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`callActionPayloads.hangup`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Will hangup the call`}</td>
        </tr>
      </tbody>
    </table>
    <p><strong parentName="p">{`Web chat options`}</strong></p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}>{`ENV Variable`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Default value`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Configuration property`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Note/Example`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`PAGE_{page.id}_ALLOW_DOMAINS`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`null`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`string`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Default application to dispatch a thread`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`allowDomains`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`"wingbot.ai, skoda-auto.cz"`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`PAGE_{page.id}_ALLOW_WEAK_AUTH`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`true`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`boolean`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Disables server-side cookie check`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`allowWeakAuth`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`PAGE_{page.id}_SESSION_EXPIRATION_SECONDS`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`7 * 24 * 3600`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`number`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Sets expiration of frontend token, so it resets the conversation then.`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`sessionExpirationSeconds`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`PAGE_{page.id}_PUBLIC_CONTEXT_PROPS`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`string`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`List of thread context variables published to frontend`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`publicContextProps`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`"foo, bar"`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`PAGE_{page.id}_RESET_ON_CONTEXT_CHANGE_PROPS`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`string`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`When contents of any provided variable changes, the chat will start over. (`}<inlineCode parentName="td">{`null`}</inlineCode>{` or `}<inlineCode parentName="td">{`undefined`}</inlineCode>{` to `}<em parentName="td">{`any`}</em>{` is not a change)`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`resetOnContextChangeProps`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`PAGE_{page.id}_OAUTH_CLIENT_ID`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`string`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`OAuth client ID`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`oauth.clientId`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`PAGE_{page.id}_OAUTH_CLIENT_SECRET`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`string`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`OAuth client secret`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`oauth.clientSecret`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`PAGE_{page.id}_OAUTH_AUTHORIZATION_ENDPOINT`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`string`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`OAuth client authorization endpoint`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`oauth.authorizationEndpoint`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`PAGE_{page.id}_OAUTH_TOKEN_ENDPOINT`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`string`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`OAuth token endpoint`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`oauth.tokenEndpoint`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`PAGE_{page.id}_OAUTH_SCOPE`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`openid`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`string`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`OAuth requested scope`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`oauth.scope`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`PAGE_{page.id}_OAUTH_RESPONSE_TYPE`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`code`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`string`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`OAuth requested scope`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`oauth.responseType`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`PAGE_{page.id}_OAUTH_STORE_USER_ID_AT_CONTEXT_PROP`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`userId`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`string`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`OAuth - stores user ID after successful authorization at a thread context variable`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`oauth.storeUserIdAtContextProp`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`PAGE_{page.id}_OAUTH_STORE_AUTH_RESULT_AT_CONTEXT_PROP`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`auth`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`string`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`OAuth - stores contents of ID token at a thread context variable`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`oauth.storeAuthResultAtContextProp`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`PAGE_{page.id}_OAUTH_BIND_THREAD_TO_SUBJECT`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`boolean`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`OAuth - each user ID will have a single conversation`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`oauth.bindThreadToSubject`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
        </tr>
      </tbody>
    </table>
    <h3>{`App Configuration`}</h3>
    <blockquote>
      <p parentName="blockquote">{`names of pages are transformed according to following example: `}<inlineCode parentName="p">{`fooBar--name0`}</inlineCode>{` to `}<inlineCode parentName="p">{`FOO_BAR_NAME0`}</inlineCode>{` (camel case to snake case except numbers, all foreign characters to single underscores)`}</p>
    </blockquote>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}>{`ENV Variable`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Default value`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Configuration property`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Note/Example`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`APP_{app.id}_CHANNEL_NAME`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`api`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`string`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Channel type`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`channelName`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`api`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`APP_{app.id}_OPTIONS_URL`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td">{`required`}</strong></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`string`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Chatbot application endpoint address`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`options.url`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`APP_{app.id}_OPTIONS_SECRET`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td">{`required`}</strong></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`string`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Chatbot application secret`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`options.secret`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`APP_{app.id}_OPTIONS_TLS_KEY`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`string`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Use client certificate private key`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`options.tls.key`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`APP_{app.id}_OPTIONS_TLS_CERT`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`string`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Use client certificate`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`options.tls.cert`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`APP_{app.id}_OPTIONS_TLS_CA`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`string`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Verify client certificate with root certificate`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`options.tls.ca`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`pem format`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`APP_{app.id}_OPTIONS_TLS_FINGER_PRINT`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`string`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Verify client certificate finger print`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`options.tls.fingerPrint`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`comma separated`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`APP_{app.id}_OPTIONS_TLS_SUBJECT_CN`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`string`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Verify client certificate subject CN`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`options.tls.subjectCN`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`comma separated`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`APP_{app.id}_OPTIONS_TLS_SUBJECT_O`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`string`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Verify client certificate subject O`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`options.tls.subjectO`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`comma separated`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`APP_{app.id}_OPTIONS_TLS_ISSUER_CN`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`string`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Verify client certificate issuer CN`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`options.tls.issuerCN`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`comma separated`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`APP_{app.id}_OPTIONS_TLS_ISSUER_O`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`string`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Verify client certificate issyer O`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`options.tls.issuerO`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`comma separated`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`APP_{app.id}_SUBSCRIPTIONS_MESSAGES`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`true`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`boolean`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Send messages to application's webhook`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`subscriptions.messages`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`APP_{app.id}_SUBSCRIPTIONS_POSTBACKS`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`true`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`boolean`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Send postbacks to application's webhook`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`subscriptions.postbacks`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`APP_{app.id}_SUBSCRIPTIONS_HANDOVERS`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`true`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`boolean`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Send handovers to application's webhook`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`subscriptions.handovers`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`APP_{app.id}_SUBSCRIPTIONS_CONTEXT_UPDATES`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`true`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`boolean`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Send thread context updates to application's webhook`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`subscriptions.contextUpdates`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`APP_{app.id}_SUBSCRIPTIONS_SENDER_ACTIONS`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`false`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`boolean`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Send sender actions to application's webhook`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`subscriptions.senderActions`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`APP_{app.id}_SUBSCRIPTIONS_STANDBY_INCOMING`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`false`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`boolean`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Send all communication from channel to application's webhook`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`subscriptions.standbyIncoming`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><em parentName="td">{`when the application is not a thread owner`}</em></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`APP_{app.id}_SUBSCRIPTIONS_SENDER_ACTIONS`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`false`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`boolean`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Send all communication from other applications to application's webhook`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`subscriptions.standbyOutgoing`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><em parentName="td">{`when the application is not a thread owner`}</em></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`APP_{app.id}_SUBSCRIPTIONS_SENDER_ACTIONS`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`false`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`boolean`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Send tracking events to application's webhook`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`subscriptions.tracking`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
        </tr>
      </tbody>
    </table>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      